export default Object.freeze({
  Concise: 1,
  Detailed: 2,
  Auto: 3,
});
